import React from 'react'
import styled from 'styled-components'

const Input = styled.input.attrs({ type: 'text' })`
  width: 100%;
  border-radius: 3px;
  padding: 10px;
  border: 1px solid #99a5ab;
`

export default React.forwardRef(({ onChange, ...rest }, ref) => (
  <Input
    ref={ref}
    onChange={onChange && (e => onChange(e.target.value))}
    {...rest}
  />
))
